// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__MqdLs","load":"Skeleton_load__waV04"};